import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import copyIcon from '../assets/copy-alt.svg';
import moreIcon from '../assets/more.svg';
import OnboardingSuccessImg from "../assets/onboarding-setup-success.png"
import PartyingFace from "../assets/welcome-partying-face.svg"
import calendarIcon from '../assets/calendar.svg';
import searchIcon from '../assets/search.svg';
import { DateRangePicker } from 'react-date-range';
import { subDays } from 'date-fns';
import Modal from 'react-bootstrap/Modal'
import ConfirmDialog from '../components/media/ConfirmDialog'
import { API } from '../utils/amplifyWrapper';
import moment from 'moment';
import { NavLink, useParams, useHistory, useLocation } from "react-router-dom";
import AudioPlayer from '../components/AudioPlayer';
import { toast } from 'react-toastify';
import Spinner from '../components/Spinner';
import * as Sentry from '@sentry/react';
import VoiceoversEmptyState from './audio/VoiceoversEmptyState';
import AudiosEmptyState from './audio/AudiosEmptyState';
import ContentItem, { CONTENT_TABLE_COLS } from '../components/content/ContentItem';
import ContentTableSkeleton from '../components/skeletons/pages/ContentTableSkeleton';
import { C } from '../styles/tokens';
import { Ico } from '../components/ui/Icons';
// Redux
import { fetchContentsRequested, fetchContentsSearchRequested, fetchContentsSuccess } from "../store/actions"
import { useGlobalStore } from '../zustand-store/useGlobalStore';
import { useQueryClient } from '@tanstack/react-query';

const classNames = require('classnames');
const COLS = CONTENT_TABLE_COLS;
const TABLE_HEADERS = [
    { label: 'Title',    cls: '' },
    { label: 'Duration', cls: 'ct-col-duration' },
    { label: 'Created',  cls: 'ct-col-created' },
    { label: 'Status',   cls: '' },
    { label: '',         cls: '' },
];

function Content({ contentType, setShowUploadAudio, setSelectedAudio }) {

    const { org_id, id } = useParams();
    const dispatch = useDispatch()
    const history = useHistory()
    const location = useLocation();
    const queryClient = useQueryClient();

    const toggle = useGlobalStore((state) => state.toggleUpgradeModal);

    const [isContentChannelsLoading, setContentChannelsLoading] = useState(true);
    const [isAddingContentToChannels, setIsAddingContentToChannels] = useState(false);
    const [podcasts, setPodcasts] = useState([]);
    const [contentPodcasts, setContentPodcasts] = useState([]);
    const [searchKeyword, setSearchKeyword] = useState("");
    const [audio, setAudio] = useState(null);
    const [audioTitle, setAudioTitle] = useState("Press play to listen to this.")
    const [showEmbedCode, setShowEmbedCode] = useState(false);
    const [embedCode, setEmbedCode] = useState('');

    const [timePeriod, setTimePeriod] = useState([
        {
            startDate: subDays(new Date(), 7),
            endDate: new Date(),
            key: 'selection'
        }
    ]);

    const [isDateFilterApplied, setIsDateFilterApplied] = useState(false)

    const [show, setShow] = useState(false);
    const [showPodcast, setShowPodcast] = useState(false);
    const [deleteConfirm, setDeleteConfirm] = useState({ show: false, item: null, index: null });


    const [contentId, setContentId] = useState(null);

    const content = useSelector((state) => state.content.contents)
    const isLoading = useSelector((state) => state.content.isLoading)
    const isFetchingMore = useSelector((state) => state.content.isFetchingMore)
    const nextPageToken = useSelector(state => state.content.nextPageToken)
    const isSearchResults = useSelector(state => state.content.isSearchResults)

    const getNextPage = () => {

        let startDate = null;
        let endDate = null;

        if (true === isDateFilterApplied) {
            startDate = moment(timePeriod[0].startDate).utc().format();
            endDate = moment(timePeriod[0].endDate).endOf('day').utc().format();
        }

        dispatch(fetchContentsRequested({ org_id, id, filter: { nextPageToken, contentType, startDate, endDate, isMore: true } }))

    }

    const getManualPodcastChannels = () => {
        return API.get('main', `/organisation/${org_id}/integration/${id}/podcast?manual`);
    };

    const getPodcastChannelsByContentId = () => {
        return API.get('main', `/organisation/${org_id}/integration/${id}/content/${contentId}/podcasts`);
    };

    const enableAudio = (content_id, index) => {

        let contents = [...content];
        let currentContent = contents[index];

        API.put(`main`, `/organisation/${org_id}/integration/${id}/content/${content_id}/enable_audio`, { headers: { "Content-Type": "application/json" } })
            .then((response) => {

                toast.success('Audio has been enabled successfully.');
                currentContent.is_audio_disabled = false;
                contents[index] = currentContent;
                dispatch(fetchContentsSuccess({ contents }))

            }).catch((error) => {

                toast.error("Something went wrong while enabling the audio.");
                Sentry.captureException(error);

            });

    }

    const discardDraft = (content_id, index) => {

        let currentContent = content[index];

        API.del('main', `/organisation/${org_id}/integration/${id}/draft_content/${content_id}`, { headers: { "Content-Type": "application/json" } }).then((response) => {

            toast.success('Draft has been discarded successfully.');
            let contents = content.filter(val => {
                if (val.SK === currentContent.SK) return false;
                return true;
            })
            dispatch(fetchContentsSuccess({ contents }))
            
            // Invalidate organisation cache to refresh audios_count
            queryClient.invalidateQueries(['organisation', org_id]);

        }).catch((error) => {

            toast.error("Something went wrong while discarding the draft.");
            Sentry.captureException(error);

        })

    }

    const deleteAudio = (content_id, index) => {

        let currentContent = content[index];

        API.del('main', `/organisation/${org_id}/integration/${id}/content/${content_id}`, { headers: { "Content-Type": "application/json" } }).then((response) => {

            toast.success('Audio has been deleted successfully.');
            let contents = content.filter(val => {
                if (val.SK === currentContent.SK) return false;
                return true;
            })
            dispatch(fetchContentsSuccess({ contents }))
            
            // Invalidate organisation cache to refresh audios_count
            queryClient.invalidateQueries(['organisation', org_id]);

        }).catch((error) => {

            toast.error("Something went wrong while deleting the audio.");
            Sentry.captureException(error);

        })

    }

    const requestDelete = (item, index) => {
        setDeleteConfirm({ show: true, item, index });
    }

    const confirmDelete = () => {
        const { item, index } = deleteConfirm;
        const content_id = item.SK.split("#")[1];

        if (item.published_at === null) {
            discardDraft(content_id, index);
        } else {
            deleteAudio(content_id, index);
        }

        setDeleteConfirm({ show: false, item: null, index: null });
    }

    const clearSearchResults = () => {
        setSearchKeyword("");
        fetchAndPopulateContents()
    }

    const searchContent = (keyword) => {

        dispatch(fetchContentsSearchRequested({ org_id, id, keyword }))

    }

    const disableAudio = (content_id, index) => {

        let contents = [...content];
        let currentContent = contents[index];

        API.put(`main`, `/organisation/${org_id}/integration/${id}/content/${content_id}/disable_audio`, { headers: { "Content-Type": "application/json" } })
            .then(() => {

                toast.success('Audio has been disabled successfully.');
                currentContent.is_audio_disabled = true;
                contents[index] = currentContent;
                dispatch(fetchContentsSuccess({ contents }))

            }).catch((error) => {

                toast.error("Something went wrong while disabling the audio.");
                Sentry.captureException(error);

            });

    }

    const CustomToggle = React.forwardRef(({ onClick }, ref) => (
        <img src={moreIcon} className="more-icon" alt="more icon" ref={ref} onClick={(e) => { e.preventDefault(); onClick(e); }} />
    ));

    const AppliedFilter = () => {
        return (
            isDateFilterApplied && (
                <div className="d-flex align-items-center gap-2 mb-3">
                        <span style={{ fontSize: 13, color: 'var(--bs-secondary-color)' }}>
                            Showing content from <strong>{moment(timePeriod[0].startDate).format('MMM Do YY')}</strong> to <strong>{moment(timePeriod[0].endDate).format('MMM Do YY')}</strong>
                        </span>
                    <button
                        onClick={() => setIsDateFilterApplied(false)}
                        className="btn btn-sm"
                        style={{ borderRadius: 50, fontSize: 12, padding: '2px 12px', background: 'rgba(var(--bs-primary-rgb),0.1)', color: 'var(--bs-primary)', border: '1px solid rgba(var(--bs-primary-rgb),0.2)' }}
                    >
                        Clear
                    </button>
                </div>
            )
        )
    }

    const Content = () => {
        const newLabel = contentType === 'audio_article' ? 'New audio article' : 'New voiceover';
        const newPath = `/organisation/${org_id}/integration/${id}/content/new`;

        return (
            <React.Fragment>
                {isSearchResults && (
                    <div className="d-flex align-items-center gap-2 mb-3">
                        <span style={{ fontSize: 13, color: C.n500 }}>
                            Results for <strong>{searchKeyword}</strong>
                        </span>
                        <button
                            onClick={() => clearSearchResults()}
                            style={{
                                borderRadius: 50, fontSize: 12, padding: '2px 12px',
                                background: `${C.p500}18`, color: C.p600,
                                border: `1px solid ${C.p200}`, cursor: 'pointer',
                            }}
                        >
                            Clear
                        </button>
                    </div>
                )}

                {/* Table container */}
                <div style={{ background: C.w, border: `1px solid ${C.n200}`, borderRadius: 13, overflow: 'hidden' }}>

                    {/* Header */}
                    <div className="content-table-row" style={{
                        padding: '9px 16px', borderBottom: `1px solid ${C.n200}`, background: '#FAFAFA',
                    }}>
                        {TABLE_HEADERS.map((h, i) => (
                            <div key={i} className={h.cls} style={{ fontSize: 11.5, fontWeight: 600, color: C.n400, letterSpacing: '.03em' }}>
                                {h.label}
                            </div>
                        ))}
                    </div>

                    {/* New row */}
                    {!isSearchResults && (
                        <button
                            onClick={() => history.push(newPath)}
                            className="content-table-row"
                            style={{
                                width: '100%',
                                padding: '10px 16px', border: 'none', borderBottom: `1px solid ${C.n100}`,
                                background: 'transparent', cursor: 'pointer', textAlign: 'left', alignItems: 'center',
                            }}
                            onMouseEnter={e => e.currentTarget.style.background = C.n50}
                            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                <div style={{
                                    width: 32, height: 32, borderRadius: 7,
                                    background: C.p50, border: `1.5px dashed ${C.p200}`,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                                }}>
                                    <Ico n="plus" size={13} color={C.p500} />
                                </div>
                                <span style={{ fontSize: 13.5, fontWeight: 600, color: C.p600 }}>{newLabel}</span>
                            </div>
                            <div className="ct-col-duration" /><div className="ct-col-created" /><div /><div />
                        </button>
                    )}

                    {/* Content rows */}
                    {(!content || !content.length) && isSearchResults ? (
                        <div style={{ padding: '28px', textAlign: 'center', color: C.n400, fontSize: 13 }}>
                            No content found. Try a different keyword.
                        </div>
                    ) : (
                        content && content.map((item, index) => (
                            <ContentItem
                                key={`content-${index}`}
                                item={item}
                                index={index}
                                org_id={org_id}
                                id={id}
                                isLast={index === content.length - 1}
                                setAudio={(e) => setAudio(e)}
                                setAudioTitle={(e) => setAudioTitle(e)}
                                setShowUploadAudio={(e) => setShowUploadAudio(e)}
                                setSelectedAudio={(e) => setSelectedAudio(e)}
                                setShowEmbedCode={(e) => setShowEmbedCode(e)}
                                setEmbedCode={(e) => setEmbedCode(e)}
                                setShowPodcast={(e) => setShowPodcast(e)}
                                setContentId={(e) => setContentId(e)}
                                disableAudio={(e, i) => disableAudio(e, i)}
                                enableAudio={(e, i) => enableAudio(e, i)}
                                requestDelete={(item, i) => requestDelete(item, i)}
                                CustomToggle={CustomToggle}
                            />
                        ))
                    )}
                </div>

                {/* Load more */}
                {!isSearchResults && (
                    isFetchingMore ? (
                        <div className="d-flex justify-content-center mt-4">
                            <Spinner color="var(--bs-primary)" />
                        </div>
                    ) : (
                        nextPageToken && (
                            <div className="d-flex justify-content-center mt-4">
                                <button
                                    onClick={() => getNextPage()}
                                    style={{
                                        borderRadius: 50, fontSize: 13, fontWeight: 500, padding: '8px 28px',
                                        background: C.w, border: `1px solid ${C.n200}`,
                                        color: C.n700, cursor: 'pointer',
                                    }}
                                >
                                    Load more
                                </button>
                            </div>
                        )
                    )
                )}
            </React.Fragment>
        );
    }

    const fetchAndPopulateContents = () => {

        setIsDateFilterApplied(false);

        // Getting contents
        dispatch(fetchContentsRequested({ org_id, id, filter: { nextPageToken: null, contentType, startDate: null, endDate: null } }))
    }

    useEffect(() => {

        const shouldShowUpgradeModal = (!!(new URLSearchParams(location.search).get('show_upgrade_modal')))
        if (shouldShowUpgradeModal) {
            toggle(true, { source: 'deep_link', isManual: false });
        }

    }, [location.search, toggle])

    useEffect(() => {

        let startDate = null;
        let endDate = null;

        if (true === isDateFilterApplied) {

            startDate = moment(timePeriod[0].startDate).utc().format();
            endDate = moment(timePeriod[0].endDate).endOf('day').utc().format();

        }

        dispatch(fetchContentsRequested({ org_id, id, filter: { nextPageToken: null, contentType, startDate, endDate } }))

        getManualPodcastChannels().then((response) => {
            setPodcasts(response.data);
        })

    }, [timePeriod, isDateFilterApplied]);

    useEffect(() => {

        fetchAndPopulateContents();

    }, [org_id, id]);

    useEffect(() => {
        setContentChannelsLoading(true);
        getPodcastChannelsByContentId()
            .then((response) => {
                const result = response.data.map((n) => {
                    return n.podcast_id;
                })
                setContentPodcasts(result);
            })
            .finally(() => {
                setContentChannelsLoading(false);
            });
    }, [contentId]);

    const onAddContentToChannel = (podcastId) => {
        setIsAddingContentToChannels(true);
        API.post('main', `/organisation/${org_id}/integration/${id}/podcast/${podcastId}/content/${contentId}`, {
            headers: { 'Content-Type': 'application/json' }
        }).then(() => {
            toast.success('Content added to the show successfully!');
        }).catch((error) => {

            toast.error("Something went wrong while creating the Podcast the show.")
            Sentry.captureException(error);

        }).finally(() => {
            setIsAddingContentToChannels(false);
        })
    };

    const onRemoveContentFromChannel = (podcastId) => {
        setIsAddingContentToChannels(true);
        API.del('main', `/organisation/${org_id}/integration/${id}/podcast/${podcastId}/episode/${contentId}`, {
            headers: { 'Content-Type': 'application/json' }
        }).then(() => {
            toast.success('Audio removed from the shows successfully!');
        }).catch((error) => {

            toast.error("Something went wrong while removing the audio from the Podcast show.")
            Sentry.captureException(error);

        }).finally(() => {
            setIsAddingContentToChannels(false);
        })
    };

    const disableOnBoardingSuccessCard = () => {
        history.replace({
            search: "",
        })
    }

    return (
        <React.Fragment>

        {/* Search bar */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
                <div style={{ flex: 1, position: 'relative' }}>
                    <Ico n="search" size={14} color={C.n400}
                        style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }} />
                    <input
                        type="text"
                        value={searchKeyword}
                        onChange={(e) => setSearchKeyword(e.target.value)}
                        onKeyDown={(e) => { if ("Enter" === e.key) searchContent(e.target.value) }}
                        placeholder={contentType === 'audio_article' ? 'Search audio articles…' : 'Search voiceovers…'}
                        style={{
                            width: '100%', padding: '8px 12px 8px 32px',
                            border: `1px solid ${C.n200}`, borderRadius: 8,
                            fontSize: 13, outline: 'none',
                            color: C.n900, background: C.w, boxSizing: 'border-box',
                        }}
                    />
                </div>
            </div>

            {/* Filter chips */}
            <div style={{ display: 'flex', gap: 6, marginBottom: 14 }}>
                <button
                    type="button"
                    onClick={() => setShow(true)}
                    style={{
                        display: 'flex', alignItems: 'center', gap: 6,
                        padding: '5px 11px', border: `1px solid ${isDateFilterApplied ? C.p300 : C.n200}`,
                        borderRadius: 6, background: isDateFilterApplied ? C.p50 : C.w,
                        fontSize: 12, color: isDateFilterApplied ? C.p600 : C.n500,
                        cursor: 'pointer', fontWeight: 500,
                    }}
                >
                    <img src={calendarIcon} alt="calendar" width="12" style={{ opacity: 0.6 }} />
                    {isDateFilterApplied ? 'Date filter applied' : '+ Filter by date'}
                </button>
                {isDateFilterApplied && (
                    <button
                        onClick={() => setIsDateFilterApplied(false)}
                        style={{
                            padding: '5px 11px', border: `1px solid ${C.n200}`, borderRadius: 6,
                            background: C.w, fontSize: 12, color: '#DC2626', cursor: 'pointer', fontWeight: 500,
                        }}
                    >
                        Clear
                    </button>
                )}
            </div>

            <Modal show={show} onHide={() => { setShow(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title>Pick a date range</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <DateRangePicker
                        onChange={item => { setTimePeriod([item.selection]); setIsDateFilterApplied(true) }}
                        showSelectionPreview={true}
                        moveRangeOnFirstSelection={false}
                        months={1}
                        ranges={timePeriod}
                        maxDate={new Date()}
                        direction="vertical"
                    />
                </Modal.Body>
            </Modal>
            <Modal show={showPodcast} onHide={() => { setShowPodcast(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Select podcast feed
                        <p className="modal-subtitle">Only podcast with "Manual" distribution are listed.</p>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        {
                            (isContentChannelsLoading || isAddingContentToChannels)
                                ? (
                                    <Spinner color="var(--bs-secondary-color)" />
                                ) : (
                                    (podcasts.length > 0)
                                        ? (
                                            podcasts.map((item, item_i) => {
                                                return (
                                                    <div key={`podcast-${item_i}`} className="form-check my-3">
                                                        <input className="form-check-input" type="checkbox" checked={contentPodcasts.indexOf(item.id) >= 0} onChange={(event) => {
                                                            let copy = [...contentPodcasts];
                                                            if (event.currentTarget.checked) {

                                                                copy.push(item.id);
                                                                setContentPodcasts(copy);
                                                                onAddContentToChannel(item.id);

                                                            } else {

                                                                copy = copy.filter(n => n !== item.id);
                                                                setContentPodcasts(copy);
                                                                onRemoveContentFromChannel(item.id);

                                                            }
                                                        }} />
                                                        <label className="form-check-label">
                                                            {item.title}
                                                        </label>
                                                    </div>
                                                )
                                            })
                                        ) : (
                                            <div className="mb-3">
                                                <p>There are no podcast shows. Start by creating one</p>
                                                <NavLink to={`/organisation/${org_id}/integration/${id}/podcast/new`} activeClassName="active">
                                                    <button className="btn btn-primary">Create new Podcast</button>
                                                </NavLink>
                                            </div>
                                        )
                                )
                        }
                    </div>
                </Modal.Body>
            </Modal>
            <Modal className="modal-embed-code" show={showEmbedCode} onHide={() => setShowEmbedCode(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Embed Code
                        <p style={{ fontSize: 16, fontWeight: 400, margin: 0 }}>Add the following line to your website’s HTML code as per below.</p>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <CopyToClipboard text={embedCode} onCopy={() => toast.success("Copied to clipboard")}>
                        <button
                            type="button"
                            className="btn btn-outline-primary position-absolute d-flex align-items-center gap-2"
                            style={{
                                right: 16,
                                top: 16,
                            }}
                        >
                            <img src={copyIcon} width="16" alt="copy icon" />
                            <span>Copy</span>
                        </button>
                    </CopyToClipboard>
                    <SyntaxHighlighter className="pt-3 pt-sm-0" language="html">
                        {embedCode}
                    </SyntaxHighlighter>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-primary me-3" onClick={() => setShowEmbedCode(false)}>Close</button>
                </Modal.Footer>
            </Modal>
            <ConfirmDialog
                open={deleteConfirm.show}
                title="Delete this item?"
                message={`Are you sure you want to delete "${deleteConfirm.item?.title || 'this item'}"? This action cannot be undone.`}
                confirmLabel="Delete"
                danger
                onConfirm={confirmDelete}
                onCancel={() => setDeleteConfirm({ show: false, item: null, index: null })}
            />

            {
                (isLoading)
                    ?
                    (
                        <ContentTableSkeleton />
                    )
                    :
                    (
                        ((content && content.length > 0) || isSearchResults)
                            ?
                            (
                                <React.Fragment>
                                    <AppliedFilter />
                                    <Content />
                                </React.Fragment>
                            )
                            :
                            (
                                (isDateFilterApplied)
                                    ?
                                    (
                                        <React.Fragment>
                                            <AppliedFilter />
                                            <p className="text-muted mt-4" style={{ fontSize: 14 }}>No content found in this date range. Try adjusting the date range.</p>
                                        </React.Fragment>
                                    )
                                    :
                                    (
                                        (contentType === "voice_over") ? <VoiceoversEmptyState orgId={org_id} integrationId={id} /> : ((contentType == "audio_article") ? <AudiosEmptyState orgId={org_id} integrationId={id} /> : null)
                                    )
                            )
                    )
            }

            {
                (audio) &&
                <div className="audio-player-wrapper">
                    <AudioPlayer onClose={() => setAudio(null)} audio={audio} title={audioTitle} />
                </div>
            }
        </React.Fragment>
    );
}

export default Content;